import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import useGetMetadataQuery from '../../reactQuery/hooks/useGetMetadata';
import { LegalDocs } from '../../lib/consts';
import {
	CONTENT_FIELDS,
	getContentFieldValue,
} from '../../lib/helpers/content.helper';
import ContentRenderer from '../Smart/Content/ContentRenderer';
import './CookiesPage.scss';

type LegalDocPageProps = {
	identity: LegalDocs;
};

const LegalDocPage: FC<LegalDocPageProps> = ({ identity }) => {
	const { data: metadata } = useGetMetadataQuery();
	const { i18n } = useTranslation();
	const currentLanguage: string = i18n.language;

	const document = metadata?.legals.find((doc) => doc.identity === identity);

	const docTitle = getContentFieldValue({
		entityContent: document?.content,
		field: CONTENT_FIELDS.NAME,
		language: currentLanguage,
	});
	const docContent = getContentFieldValue({
		entityContent: document?.content,
		field: CONTENT_FIELDS.CONTENT,
		language: currentLanguage,
	});

	return (
		<div className="CookiesPage">
			<Typography variant="h3" component="h1">
				{docTitle}
			</Typography>
			<ContentRenderer html={docContent} />
		</div>
	);
};

export default LegalDocPage;
